import React from 'react';
import PropTypes from 'prop-types';
import onlyASCII from '@htmniseko/htm-validators/utils/ASCII/onlyASCII';
import TextField from './TextField';

const PasswordField = ({ id, name, hideLabel, label, fieldSizeSM, required }) => (
  <TextField
    fullWidth
    id={id}
    hideLabel={hideLabel}
    hideRequiredAsterisk
    label={label}
    name={name}
    normalize={onlyASCII}
    type="password"
    childrenSizeSM={fieldSizeSM}
    required={required}
  />
);

PasswordField.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  hideLabel: PropTypes.bool,
  label: PropTypes.string,
  fieldSizeSM: PropTypes.number,
  required: PropTypes.bool,
};

PasswordField.defaultProps = {
  hideLabel: false,
  fieldSizeSM: 9,
  required: false,
};

export default PasswordField;
